import React, { useMemo, useState } from 'react';
import { Outlet, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleLeft,
  faAngleRight,
  faBars,
  faBell,
  faBriefcase,
  faBuilding,
  faBookOpen,
  faCalendarCheck,
  faChartLine,
  faChevronDown,
  faFolderOpen,
  faGaugeHigh,
  faGraduationCap,
  faHeadset,
  faListCheck,
  faMoneyBillWave,
  faRightFromBracket,
  faSearch,
  faUserTie,
  faUsers,
  faUserShield,
  faBoxesStacked,
} from '@fortawesome/free-solid-svg-icons';

import './DashboardLayout.css';
import logo from '../assets/company-logo.png';

function DashboardLayoutErp({ user, setUser }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [openGroups, setOpenGroups] = useState({
    dashboard: true,
    master: true,
    crm: true,
    transaction: true,
    operations: true,
  });

  const menus = useMemo(() => ({
    admin: [
      {
        key: 'dashboard',
        title: 'Dashboard',
        icon: faGaugeHigh,
        items: [{ name: 'Admin Dashboard', path: '/dashboard/home', icon: faGaugeHigh, permission: 'dashboard' }],
      },
      {
        key: 'master',
        title: 'Master',
        icon: faFolderOpen,
        items: [
          { name: 'User Management', path: '/dashboard/manage-users', icon: faUserShield, permission: 'users' },
          { name: 'Manage Staff', path: '/dashboard/manage-staff', icon: faUserTie, permission: 'hr' },
          { name: 'Manage Batches', path: '/dashboard/manage-batches', icon: faUsers, permission: 'batch' },
          { name: 'Inventory', path: '/dashboard/inventory', icon: faBoxesStacked, permission: 'inventory' },
        ],
      },
      {
        key: 'crm',
        title: 'CRM & CRE',
        icon: faBuilding,
        items: [
          { name: 'Clients', path: '/dashboard/clients', icon: faBuilding, permission: 'projects' },
          { name: 'Client Queries', path: '/dashboard/client-queries', icon: faHeadset, permission: 'projects' },
          { name: 'Manage Students', path: '/dashboard/manage-students', icon: faGraduationCap, permission: 'students' },
          { name: 'Lead Management', path: '/dashboard/lead-management', icon: faChartLine, permission: 'admission' },
          { name: 'Workshop Registrations', path: '/dashboard/workshop-registrations', icon: faUsers, permission: 'admission' },
        ],
      },
      {
        key: 'transaction',
        title: 'Transactions',
        icon: faMoneyBillWave,
        items: [
          { name: 'Expense Tracker', path: '/dashboard/expense-tracker', icon: faMoneyBillWave, permission: 'fees' },
          { name: 'Manage Tasks', path: '/dashboard/tasks', icon: faListCheck, permission: 'tasks' },
        ],
      },
      {
        key: 'operations',
        title: 'HR & Operations',
        icon: faBriefcase,
        items: [
          { name: 'My Tasks', path: '/dashboard/mytasks', icon: faListCheck, permission: 'tasks' },
          { name: 'Hiring', path: '/dashboard/hiring', icon: faBriefcase, permission: 'hr' },
          { name: 'HR Module', path: '/dashboard/hr', icon: faUserTie, permission: 'hr' },
          { name: 'Staff Attendance', path: '/dashboard/staff-attendance', icon: faCalendarCheck, permission: 'attendance' },
        ],
      },
    ],
    staff: [
      {
        key: 'dashboard',
        title: 'Dashboard',
        icon: faGaugeHigh,
        items: [{ name: 'Staff Dashboard', path: '/dashboard/staff-home', icon: faGaugeHigh, permission: 'dashboard' }],
      },
     {
  key: 'master',
  title: 'Master',
  icon: faFolderOpen,
  items: [
    {
      name: 'Admissions',
      path: '/dashboard/admission',
      icon: faGraduationCap,
      permission: 'admission',
    },
    {
      name: 'Course Management',
      path: '/dashboard/course-management',
      icon: faBookOpen,
      permission: 'courses',
    },
    {
      name: 'Interns',
      path: '/dashboard/interns',
      icon: faUserTie,
      permission: 'students',
    },
    {
      name: 'Manage Batches',
      path: '/dashboard/manage-batches',
      icon: faFolderOpen,
      permission: 'batch',
    },
    {
      name: 'Inventory',
      path: '/dashboard/inventory',
      icon: faBoxesStacked,
      permission: 'inventory',
    },
  ],
},
      {
        key: 'crm',
        title: 'CRM & CRE',
        icon: faBuilding,
        items: [
          { name: 'Clients', path: '/dashboard/clients', icon: faBuilding, permission: 'projects' },
          { name: 'Client Queries', path: '/dashboard/client-queries', icon: faHeadset, permission: 'projects' },
          { name: 'Manage Students', path: '/dashboard/manage-students', icon: faUsers, permission: 'students' },
          { name: 'Admissions', path: '/dashboard/admission', icon: faGraduationCap, permission: 'admission' },
          { name: 'Leads', path: '/dashboard/leads', icon: faChartLine, permission: 'admission' },
          { name: 'Workshop Registrations', path: '/dashboard/workshop-registrations', icon: faUsers, permission: 'admission' },
        ],
      },
      {
        key: 'transaction',
        title: 'Transactions',
        icon: faMoneyBillWave,
        items: [
          { name: 'Billing', path: '/dashboard/billing', icon: faMoneyBillWave, permission: 'billing' },
          { name: 'Petty Cash', path: '/dashboard/petty-cash', icon: faMoneyBillWave, permission: 'fees' },
          { name: 'Reports', path: '/dashboard/reports', icon: faChartLine, permission: 'reports' },
        ],
      },
      {
        key: 'operations',
        title: 'Operations',
        icon: faBriefcase,
        items: [
          { name: 'My Tasks', path: '/dashboard/mytasks', icon: faListCheck, permission: 'tasks' },
          { name: 'Hiring', path: '/dashboard/hiring', icon: faBriefcase, permission: 'hr' },
          { name: 'HR Module', path: '/dashboard/hr', icon: faUserTie, permission: 'hr' },
          { name: 'Leave & Salary', path: '/dashboard/leave-salary', icon: faCalendarCheck, permission: 'leave' },
        ],
      },
    ],
    student: [
      {
        key: 'student',
        title: 'Student',
        icon: faGraduationCap,
        items: [
          { name: 'My Home', path: '/dashboard/student-home', icon: faGaugeHigh },
          { name: 'Assignments', path: '/dashboard/assignments', icon: faListCheck },
        ],
      },
    ],
    client: [
      {
        key: 'client',
        title: 'Client Portal',
        icon: faHeadset,
        items: [
          { name: 'Project Queries', path: '/dashboard/client-support', icon: faHeadset },
        ],
      },
    ],
  }), []);

  const normalizedRole = String(user?.role || '').toLowerCase().replaceAll(' ', '_');
  const canView = (permission) => !permission || normalizedRole === 'admin' || normalizedRole === 'super_admin' || user?.permissions?.[permission]?.view;
  const baseMenuKey = normalizedRole === 'admin' || normalizedRole === 'super_admin' ? 'admin' : normalizedRole;
  const menuGroups = (menus[user?.role] || menus[baseMenuKey] || menus.staff || [])
    .map((group) => ({ ...group, items: group.items.filter((item) => canView(item.permission)) }))
    .filter((group) => group.items.length);
  const roleLabel = user?.role ? user.role.toUpperCase() : 'ERP';

  const handleLogout = () => {
    localStorage.removeItem('user');
    setUser(null);
    navigate('/');
  };

  const isGroupActive = (group) =>
    group.items.some((item) => location.pathname.toLowerCase() === item.path.toLowerCase());

  const toggleGroup = (key) => {
    if (isCollapsed) return;
    setOpenGroups((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className={`layout-wrapper ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
      <aside className={`sidebar ${isSidebarOpen ? 'open' : ''} ${isCollapsed ? 'collapsed' : ''}`}>
        <button className="sidebar-mobile-close" onClick={() => setIsSidebarOpen(false)} aria-label="Close sidebar">
          x
        </button>

        <div className="brand-panel">
          <img src={logo} alt="Company Logo" className="sidebar-logo" />
          <div className="brand-copy">
            <h5>Semicolon ERP</h5>
            <span>{roleLabel} Workspace</span>
          </div>
          <button
            className="collapse-toggle"
            onClick={() => setIsCollapsed(!isCollapsed)}
            aria-label="Collapse sidebar"
            title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
           <FontAwesomeIcon
    icon={faAngleLeft}
    className={isCollapsed ? "rotate-icon" : ""}
/>
          </button>
        </div>

        <nav className="menu">
          {menuGroups.map((group) => (
            <div className={`menu-group ${isGroupActive(group) ? 'group-active' : ''}`} key={group.key}>
              <button className="menu-group-title" onClick={() => toggleGroup(group.key)} title={group.title}>
                <span className="menu-icon"><FontAwesomeIcon icon={group.icon} /></span>
                <span className="menu-label">{group.title}</span>
                <FontAwesomeIcon className={`group-caret ${openGroups[group.key] ? 'open' : ''}`} icon={faChevronDown} />
              </button>

              <div
  className={`menu-group-items ${
    isCollapsed || openGroups[group.key] ? "open" : ""
  }`}
>
                {group.items.map((item) => (
                  <NavLink
                    key={item.name}
                    to={item.path}
                    title={item.name}
                    className={({ isActive }) => `menu-item ${isActive ? 'active' : ''}`}
                    onClick={() => {
                      if (window.innerWidth <= 768) setIsSidebarOpen(false);
                    }}
                  >
                    <span className="menu-icon"><FontAwesomeIcon icon={item.icon} /></span>
                    <span className="menu-label">{item.name}</span>
                  </NavLink>
                ))}
              </div>
            </div>
          ))}
        </nav>

        <div className="logout-section">
          <div className="user-chip">
            <span className="user-avatar">{user?.name?.charAt(0)?.toUpperCase() || 'U'}</span>
            <span className="user-meta">
              <strong>{user?.name}</strong>
              <small>{roleLabel}</small>
            </span>
          </div>
          <Button variant="outline-light" className="logout-btn" onClick={handleLogout} title="Logout">
            <FontAwesomeIcon icon={faRightFromBracket} />
            <span>Logout</span>
          </Button>
        </div>
      </aside>

      <main className="content">
        <header className="erp-topbar">
          <button className="mobile-menu-btn" onClick={() => setIsSidebarOpen(true)} aria-label="Open sidebar">
            <FontAwesomeIcon icon={faBars} />
          </button>
          <div className="topbar-title">
            <span>Corporate ERP</span>
            <strong>{user?.name}</strong>
          </div>
          <div className="topbar-actions">
            <div className="topbar-search">
              <FontAwesomeIcon icon={faSearch} />
              <input placeholder="Search modules..." />
            </div>
            <button className="topbar-icon-btn" aria-label="Notifications">
              <FontAwesomeIcon icon={faBell} />
            </button>
          </div>
        </header>

        <div className="content-inner">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default DashboardLayoutErp;
